/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsWriteResetUserPermissionsMutationResponse, UsersAuthzAPIAdminPermissionsWriteResetUserPermissionsPathParams } from "../models/UsersAuthzAPIAdminPermissionsWriteResetUserPermissions";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { usersAuthzAPIAdminPermissionsWriteResetUserPermissions } from "../axios/usersAuthzAPIAdminPermissionsWriteResetUserPermissions";
import { useMutation } from "@tanstack/react-query";

export const usersAuthzAPIAdminPermissionsWriteResetUserPermissionsMutationKey = () => ["users-authz-api", { url: '/admin/user/:userId/permissions/reset' }] as const

export type UsersAuthzAPIAdminPermissionsWriteResetUserPermissionsMutationKey = ReturnType<typeof usersAuthzAPIAdminPermissionsWriteResetUserPermissionsMutationKey>

/**
 * @summary Reset all permissions for a user
 * {@link /admin/user/:userId/permissions/reset}
 */
export function useUsersAuthzAPIAdminPermissionsWriteResetUserPermissions<TContext>(options: 
{
  mutation?: UseMutationOptions<UsersAuthzAPIAdminPermissionsWriteResetUserPermissionsMutationResponse, ResponseErrorConfig<Error>, {userId: UsersAuthzAPIAdminPermissionsWriteResetUserPermissionsPathParams["userId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? usersAuthzAPIAdminPermissionsWriteResetUserPermissionsMutationKey()

  return useMutation<UsersAuthzAPIAdminPermissionsWriteResetUserPermissionsMutationResponse, ResponseErrorConfig<Error>, {userId: UsersAuthzAPIAdminPermissionsWriteResetUserPermissionsPathParams["userId"]}, TContext>({
    mutationFn: async({ userId }) => {
      return usersAuthzAPIAdminPermissionsWriteResetUserPermissions(userId, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}